module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-48-min.c7f32173.jpg";